var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7919 39.2171V17.0638C22.7919 16.1477 22.7919 15.6897 22.9585 15.3182C23.1054 14.9907 23.342 14.7115 23.6409 14.5127C23.9799 14.2872 24.4317 14.2119 25.3354 14.0613L42.0769 11.2711C43.2963 11.0678 43.906 10.9662 44.3812 11.1427C44.7982 11.2976 45.1477 11.5937 45.369 11.9795C45.6212 12.4192 45.6212 13.0373 45.6212 14.2736V35.4122M22.7919 39.2171C22.7919 42.3691 20.2366 44.9244 17.0845 44.9244C13.9325 44.9244 11.3772 42.3691 11.3772 39.2171C11.3772 36.065 13.9325 33.5097 17.0845 33.5097C20.2366 33.5097 22.7919 36.065 22.7919 39.2171ZM45.6212 35.4122C45.6212 38.5642 43.066 41.1195 39.9139 41.1195C36.7618 41.1195 34.2066 38.5642 34.2066 35.4122C34.2066 32.2601 36.7618 29.7048 39.9139 29.7048C43.066 29.7048 45.6212 32.2601 45.6212 35.4122Z",
    stroke: "#424242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9141 41.1195C43.0662 41.1195 45.6215 38.5643 45.6215 35.4122C45.6215 32.2601 43.0662 29.7048 39.9141 29.7048C36.7621 29.7048 34.2068 32.2601 34.2068 35.4122C34.2068 38.5643 36.7621 41.1195 39.9141 41.1195Z",
    stroke: "#D34646",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0845 44.9244C20.2366 44.9244 22.7919 42.3692 22.7919 39.2171C22.7919 36.065 20.2366 33.5098 17.0845 33.5098C13.9325 33.5098 11.3772 36.065 11.3772 39.2171C11.3772 42.3692 13.9325 44.9244 17.0845 44.9244Z",
    stroke: "#D34646",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/Music.bd609e235b953be89b1ff9917024f552.svg";
export { ForwardRef as ReactComponent };